/**
 * Rates（/app/ppe-pricing）。侧边栏 Rates。
 * 打开页面打 STATSIG.COMMON.VIEW，value=rates。
 * 点 Check rates（或历史 / Top searches 重跑）出结果才打 SEARCH。
 * 属性 source=check_rates|history|top_search
 *
 * 只覆盖 /app/ppe-pricing。GMCC Celebrity / Universe 不跨到这里。
 * 结果表里关费用、报问题下一步再拆。
 */
export enum RatesEvent {
    /**
     * 询价出结果。
     * 属性 source=check_rates|history|top_search
     */
    SEARCH = 'RATES_SEARCH',
    /**
     * 点 Add lenders 打开弹窗。
     * value 与 metadata.type 相同：click_open_popup
     * 弹窗里增删改 lender 走 STATSIG.LENDERS.INSERT / UPDATE / DELETE
     */
    ADD_LENDERS_BUTTON = 'RATES_ADD_LENDERS_BUTTON',
    /**
     * Recent search：打开抽屉，或点一条历史。
     * value 与 metadata.type 相同：click_open_popup | item_open
     */
    RECENT_SEARCH_BUTTON = 'RATES_RECENT_SEARCH_BUTTON',
    /**
     * 结果表切换 Eligibles / Ineligibles。
     * value 与 metadata.type 相同：eligibles|ineligibles
     */
    RESULT_TAB = 'RATES_RESULT_TAB',
    /** Download rate sheet */
    DOWNLOAD_RATE_SHEET_BUTTON = 'RATES_DOWNLOAD_RATE_SHEET_BUTTON',
    /**
     * View fee sheet。
     * value 与 metadata.type 相同：preview|export
     */
    VIEW_FEE_SHEET_BUTTON = 'RATES_VIEW_FEE_SHEET_BUTTON',
}
